import Vue from 'vue'
import App from './App'
import router from './router'
import vbclass from 'vue-body-class'
import vueMoment from 'vue-moment'
import AwesomeMask from 'awesome-mask'
import ToggleButton from 'vue-js-toggle-button'
import VeeValidate from 'vee-validate'
import cnpjValidator from './validators/cnpj-validator'
import br from 'vee-validate/dist/locale/pt_BR'

import { store } from './store/store.js'

require('moment/locale/pt-br')

Vue.use(vbclass, router)
Vue.use(vueMoment)
Vue.use(AwesomeMask)
Vue.use(ToggleButton)

VeeValidate.Validator.extend('cnpj', cnpjValidator)
Vue.use(VeeValidate, { locale: 'pt_BR', dictionary: { 'pt_BR': br } })

Vue.directive('mask', AwesomeMask)

window.addEventListener('keyup', (e) => {
  if ((e.altKey && e.keyCode === 84) && window.location.pathname !== '/') {
    router.push({ path: '/lockscreen' })
  }
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js